import { SubjectReviewNoteDto } from '@interfaces-clean/subject-monitoring.interface';

export type ActiveReviewNote = {
    id: string;
    recordId: number;
    text: string;
    observationDate: string;
    createdDate: string;
    createdBy: string;
    updatedDate: string;
    updatedBy: string;
    subjectNumber: string;
};

// Maps SubjectReviewNoteDto (API response, where everything is nullable) to known/validated shape
// Returns null if data is not expected shape
export const mapActiveReviewNote = (data: SubjectReviewNoteDto): ActiveReviewNote | null => {
    if (typeof data.id !== 'string') {
        return null;
    }
    if (typeof data.recordId !== 'number') {
        return null;
    }
    if (typeof data.noteText !== 'string') {
        return null;
    }
    if (typeof data.observationDate !== 'string') {
        return null;
    }
    if (typeof data.created !== 'string') {
        return null;
    }
    if (typeof data.createdByName !== 'string') {
        return null;
    }
    if (typeof data.updatedDate !== 'string') {
        return null;
    }
    if (typeof data.updatedByName !== 'string') {
        return null;
    }
    if (typeof data.subjectNumber !== 'string') {
        return null;
    }

    return {
        id: data.id,
        recordId: data.recordId,
        text: data.noteText,
        observationDate: data.observationDate,
        createdDate: data.created,
        createdBy: data.createdByName,
        updatedDate: data.updatedDate,
        updatedBy: data.updatedByName,
        subjectNumber: data.subjectNumber,
    };
};
